// extracted by mini-css-extract-plugin
export default {"surcharge":"G3e834b","valueBackground":"Gcfc127"};